import type {FailedItemAdd, ItemBeingAdded, LoggableFailedItemAdd} from '@PosterWhiteboard/page/page.types';

/**
 * Pairs every rejected add with the item it belonged to. `addResults` must be index-aligned with
 * `itemsBeingAdded` (the settled results of the promises pushed alongside each item).
 */
export const getFailedItemAdds = (itemsBeingAdded: ItemBeingAdded[], addResults: PromiseSettledResult<void>[]): FailedItemAdd[] => {
  const failedItemAdds: FailedItemAdd[] = [];
  addResults.forEach((addResult, index) => {
    if (addResult.status === 'rejected') {
      failedItemAdds.push({...itemsBeingAdded[index], reason: addResult.reason});
    }
  });
  return failedItemAdds;
};

export const getLoggableFailedItemAdds = (failedItemAdds: FailedItemAdd[]): LoggableFailedItemAdd[] => {
  return failedItemAdds.map(({uid, gitype, reason}) => {
    return {uid, gitype, errorMessage: reason instanceof Error ? reason.message : String(reason)};
  });
};
